import { SEARCH_EXPERIMENTAL_PARAMS_KEY as featureName } from "../../lib/api/constants";
import { useContext, useEffect } from "react";
import { decisionsContext, audienceContext } from "../Features";
import activateMvtFeature from "../../client/activateMvtFeature";

const useExperimentalParamsActivation = () => {
  const decisions = useContext(decisionsContext);
  const audience = useContext(audienceContext);
  const decision = decisions?.[featureName];
  useEffect(() => {
    if (decision) {
      activateMvtFeature({ featureName, audience });
    }
  }, [decision]);
};

export default useExperimentalParamsActivation;
